export default __webpack_public_path__ + "static/media/nazcan4.be70f51b.jpg";